<div class="container-auto">
    <content>
      <app-antecedentes-hospitalizacion *ngIf="mostrarAntecedentes"></app-antecedentes-hospitalizacion>
      <app-stepper></app-stepper>
      <app-paso1-auto-admision *ngIf="mostrarPaso1"></app-paso1-auto-admision>
      <app-paso2-auto-admision *ngIf="mostrarPaso2"></app-paso2-auto-admision>
      <app-paso3-auto-admision *ngIf="mostrarPaso3"></app-paso3-auto-admision>
    </content>
  <app-loader></app-loader>
</div>